<!-- Other scripts... -->

  document.addEventListener('DOMContentLoaded', function() {
    // Open popup from Open Popup button
    var openPopupBtn = document.getElementById('openPopupBtn');
    if(openPopupBtn){
      openPopupBtn.addEventListener('click', function() {
        document.getElementById('popupOverlay').style.display = 'flex';
      });
    }
    // Open popup from separate button
    var findNearBtn = document.getElementById('findnear');
    if(findNearBtn){
      findNearBtn.addEventListener('click', function(event) {
        event.preventDefault();
        document.getElementById('popupOverlay').style.display = 'flex';
      });
    }
    // Close popup
    var closePopupBtn = document.getElementById('closePopupBtn');
    if(closePopupBtn){
      closePopupBtn.addEventListener('click', function() {
        document.getElementById('popupOverlay').style.display = 'none';
      });
    }
    // Tab switching logic
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');
    tabBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        tabBtns.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));
        this.classList.add('active');
        const tabId = this.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('active');
      });
    });
  });

